import { useState, useEffect } from 'react';

/**
 * Custom Hook für Mobile-Detection
 * @param {number} breakpoint - Breakpoint in Pixel (default: 768)
 * @returns {boolean} true wenn Viewport < breakpoint
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    
    // Initial check
    handleResize();
    
    // Event Listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);
  
  return isMobile;
}

